<div>
  <label
    *ngIf="label"
    class="go-form__label"
    [attr.for]="_id"
    [ngClass]="{ 'go-form__label--dark': theme === 'dark' }"
  >
    {{ label }}
    <go-required-text [control]="control"></go-required-text>
  </label>
  <textarea
    class="go-form__input go-form__textarea"
    [id]="_id"
    [ngClass]="inputClasses"
    [placeholder]="placeholder"
    [rows]="rows"
    [formControl]="control"
    [maxlength]="maxlength"
    [minlength]="minlength"
  ></textarea>

  <go-hint
    *ngFor="let hint of hints"
    [message]="hint"
    [theme]="theme"
  ></go-hint>
  <div *ngIf="!hideFieldError">
    <go-form-errors [control]="control" [theme]="theme"></go-form-errors>
  </div>
</div>
